module.exports = __webpack_public_path__ + "img/events.8bb503a1.jpg";